import { RolesService } from "@/services/api-service";

const state = {
  count: 0,
  pages: 1,
  list: [],
  current: {},
  original: {},
  originalJSON: ""
};

const getters = {
  count: state => state.count,
  pages: state => state.pages,
  list: state => state.list,
  current: state => state.current,
  isDirty: state => {
    const currentJSON = JSON.stringify(state.current);
    return currentJSON !== state.originalJSON;
  }
};

const actions = {
  async fetchList(context, params) {
    if (params.offset === 0) context.commit("reset");
    const { data } = await RolesService.query(params);
    context.commit("set", {
      result: data,
      limit: params.limit
    });
  },

  async fetch(context, id) {
    const { data } = await RolesService.get(id);
    context.commit("setCurrent", data.role);
  },
  async add(context, role) {
    await RolesService.add(role);
    await context.dispatch("fetchList", { limit: 20, offset: 0 });
  },
  async save(context) {
    await RolesService.save(state.current);
    context.commit("setCurrent", state.current);
  },
  async delete(context) {
    await RolesService.destroy(state.current.id);
    context.commit("remove", state.current);
  }
};

const mutations = {
  set(state, data) {
    state.list.push(...data.result.roles);
    state.count = data.result.rolesCount;
    state.pages =
      Math.ceil(state.count / data.limit) == 0
        ? 1
        : Math.ceil(state.count / data.limit);
  },
  reset(state) {
    state.list = [];
    state.count = 0;
    state.pages = 1;
  },
  setCurrent(state, entity) {
    state.original = entity;
    state.current = entity;
    state.originalJSON = JSON.stringify(state.original);
  },
  remove(state, entity) {
    state.list.splice(state.list.indexOf(entity), 1);
    state.current = {};
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
